import React, { useState, useEffect, useRef } from "react";
import Loader from "./Loader";
import Constants from "../constants/Constants";
import CommentItem from "./CommentItem";
const hideComments = () => {
  document.body.classList.remove(Constants.COMMENT_POP_CLASS);
};
const Comments = ({
  displayComments,
  vid,
  addNewComment,
  join,
  modelInfo,
  isMember,
  avatar,
  commentsLoaded,
}) => {
  const [newComment, setNewComment] = useState("");
  const [scroll, setScroll] = useState(28);
  const toBottom = useRef(null);
  const handleKeyDown = (e) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      sendComment();
    }
  };
  useEffect(() => {
    if (toBottom.current !== null) {
      toBottom.current.scrollTop = toBottom.current.scrollHeight;
    }
  }, [displayComments]);
  useEffect(() => {
    if (commentsLoaded) {
      toBottom.current.scrollTop = toBottom.current.scrollHeight;
    }
  }, [commentsLoaded]);
  useEffect(() => {
    return () => document.body.classList.remove(Constants.COMMENT_POP_CLASS);
  }, []);
  const sendComment = () => {
    if (!isMember) {
      join(modelInfo);
      return;
    }
    if (newComment == null || newComment === "") {
      return;
    }
    let formData = new FormData();
    formData.append("comment", newComment);
    formData.append("vid", vid);
    fetch(`${Constants.API}add_comment.php`, {
      credentials: "include",
      method: "POST",
      body: formData,
    });
    let newID = 1;
    if (displayComments.length > 0) {
      newID = parseInt(displayComments[displayComments.length - 1].id) + 1;
    }
    addNewComment({
      avatar: avatar,
      id: newID,
      comment: newComment,
    });
    setNewComment("");
    setScroll(28);
  };

  return (
    <div className="comments_content">
      <div className="headline">
        <span>
          {displayComments.length} <em>comments</em>
        </span>
        <button
          type="button"
          className="close"
          id="buttonClose"
          onClick={hideComments}
        >
          <i className="icon-close" />
        </button>
      </div>
      {!commentsLoaded ? (
        <Loader smaller />
      ) : (
        <>
          <div className="main_comments" ref={toBottom}>
            {displayComments.map((comment) => (
              <CommentItem
                comment={comment}
                key={`com${comment.id}`}
                modelAv={modelInfo.site_url}
              />
            ))}
          </div>
          <div className="write_panel">
            <div className="columns">
              <div className="column">
                <textarea
                  style={{ height: scroll }}
                  className="msg_field"
                  name="message"
                  placeholder="Say something..."
                  value={newComment}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => {
                    setNewComment(e.target.value);
                    if (e.target.scrollHeight > scroll) {
                      setScroll(e.target.scrollHeight + 10);
                    }
                  }}
                />
              </div>
              <div className="column second">
                <button type="submit" className="button" onClick={sendComment}>
                  <i className="icon-send" />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Comments;
